import { DebtCollectionTaskFormDto, type DebtCollectionTaskFormInterface } from '@zaoblako/shared/modules/debts/dtos/debt-collection-task/debt-collection-task-form.dto';
import {
  DebtCollectionTaskEventFormDto,
  type DebtCollectionTaskEventFormInterface,
} from '@zaoblako/shared/modules/debts/dtos/debt-collection-task-event/debt-collection-task-event-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DebtsDtoKeysEnum } from '@zaoblako/shared/modules/debts/enums/debts-dto-keys.enum';

import * as yup from 'yup';

/** Debt collection task create API request body - DTO signature */
export interface DebtCollectionTaskCreateInterface extends DebtCollectionTaskFormInterface {
  /** Task events */
  events?: DebtCollectionTaskEventFormInterface[];
}

/** Debt collection task create API request body - DTO schema */
export const DebtCollectionTaskCreateDto = SerdeDtoClass.from<DebtCollectionTaskFormInterface, DebtCollectionTaskCreateInterface>(
  DebtCollectionTaskFormDto,
  DebtsDtoKeysEnum.DEBT_COLLECTION_TASK_CREATE_DTO,
  {
    events: {
      optional: true,
      label: 'События',
      nested: DebtCollectionTaskEventFormDto,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
